// Stable public entry points shared by Dashboard and Desktop.
// Scenarios and operating instructions live online, outside the app release.
export const DESKTOP_DOWNLOAD_URL = "https://www.nodebase.com/desktop/";
export const WORKER_GUIDE_URL = "https://www.nodebase.com/agents/";
export const AGENT_SKILL_URL = "https://www.nodebase.com/agents/nodebase/SKILL.md";

export function aiStarterPrompt(locale: "en" | "zh-CN" = "en"): string {
  return locale === "zh-CN"
    ? `请阅读 ${AGENT_SKILL_URL} 中的最新引导，帮助我使用 Nodebase。场景和工作方式在 ${WORKER_GUIDE_URL}；请沿用我已说明的目标，否则按最新引导提供几个具体选择。`
    : `Read the current guide at ${AGENT_SKILL_URL} and help me use Nodebase. Scenarios and work modes are at ${WORKER_GUIDE_URL}; use the goal I have already given, or offer concrete choices from the current guide.`;
}
